import {
    DEFAULT_SETTINGS_TAB,
    isSettingsTabId,
    type WorkspaceSettingsTabId,
} from '@/features/workspace/navigation/settings-tabs';

/** Workspace route query key for the full-page Settings overlay. */
export const WORKSPACE_SETTINGS_QUERY_KEY = 'setting';

export function getWorkspaceSettingsTabFromSearchParams(
    searchParams: URLSearchParams
): WorkspaceSettingsTabId | undefined {
    const tab = searchParams.get(WORKSPACE_SETTINGS_QUERY_KEY) ?? undefined;
    return isSettingsTabId(tab) ? tab : undefined;
}

export function isWorkspaceSettingsOpen(searchParams: URLSearchParams): boolean {
    return Boolean(getWorkspaceSettingsTabFromSearchParams(searchParams));
}

export function applyWorkspaceSettingsTab(
    searchParams: URLSearchParams,
    tab: WorkspaceSettingsTabId | null | undefined
): URLSearchParams {
    const next = new URLSearchParams(searchParams);

    if (tab && isSettingsTabId(tab)) {
        next.set(WORKSPACE_SETTINGS_QUERY_KEY, tab);
        return next;
    }

    next.delete(WORKSPACE_SETTINGS_QUERY_KEY);
    return next;
}

export function openWorkspaceSettingsSearchParams(
    searchParams: URLSearchParams,
    tab: WorkspaceSettingsTabId = DEFAULT_SETTINGS_TAB
): URLSearchParams {
    return applyWorkspaceSettingsTab(searchParams, tab);
}

export function closeWorkspaceSettingsSearchParams(
    searchParams: URLSearchParams
): URLSearchParams {
    return applyWorkspaceSettingsTab(searchParams, null);
}
